// Cuts and Wounds
import press from './CutsWounds/WhatHelps/CutsAndWounds/press.svg';
import clean from './CutsWounds/WhatHelps/CutsAndWounds/wash.svg';
import cover from './CutsWounds/WhatHelps/CutsAndWounds/cover.svg';
import washHands from './CutsWounds/WhatHelps/CutsAndWounds/washHands.png';
import badPain from './CutsWounds/WhenToSay/CutsAndWounds/badpain.svg';
import bite from './CutsWounds/WhenToSay/CutsAndWounds/bite.svg';
import deepCut from './CutsWounds/WhenToSay/CutsAndWounds/cut.svg';
import bleeding from './CutsWounds/WhenToSay/CutsAndWounds/bleeding.svg';
import pourOil from './CutsWounds/WhatHelps/CutsAndWounds/PourOil.svg';
import putSugar from './CutsWounds/WhatHelps/CutsAndWounds/PutSugar.svg';
import toothpaste from './CutsWounds/WhatHelps/CutsAndWounds/toothpaste.svg';
import cutsBanner from './CutsWounds/cutsbanner.svg';
// Nose bleeding
import noseBleedingBanner from './Nosebleeding/Nosebleed.svg';
import sitUp from './Nosebleeding/WhatHelps/situp.svg';
import leanFoward from './Nosebleeding/WhatHelps/LeanFoward.svg';
import pinchSoftPart from './Nosebleeding/WhatHelps/PinchSoftPart.svg';
import breatheViaMouth from './Nosebleeding/WhatHelps/BreatheViaMouth.svg';
import alotOfBlood from './Nosebleeding/WhenToSay/AlotOfBlood.svg';
import bleedingNotStopping from './Nosebleeding/WhenToSay/BleedingNotStopping.svg';
import breathingDifficulties from './Nosebleeding/WhenToSay/BreathingDifficulties.svg';
import swollenNose from './Nosebleeding/WhenToSay/SwollenNose.svg';
import run from './Nosebleeding/WhatHelps/run.svg';
import lieFlat from './Nosebleeding/WhatHelps/lieflat.svg';
import breatheViaNose from './Nosebleeding/WhatHelps/breatheViaNose.svg';
import putThings from './Nosebleeding/WhatHelps/putthings.svg';
// burns and scalds
import burnsBanner from './Burns/BurnsandScalds.svg';
import burnsRest from './Burns/WhatHelps/rest.svg';
import stayAwayFire from './Burns/WhatHelps/stayAwayFire.png';
import coolWithWater from './Burns/WhatHelps/cool.svg';
import coverBurn from './Burns/WhatHelps/cover.svg';
import takeMedicine from './Burns/WhatHelps/takeMedicine.svg';
import burntHand from './Burns/WhenToSay/burntHand.svg';
import blister from './Burns/WhenToSay/blister.svg';
import fromChemicals from './Burns/WhenToSay/fromChemicals.svg';
import cantBreathe from './Burns/WhenToSay/cantBreathe.svg';
import burnsPutSugar from './Burns/WhenToSay/putSugar.svg';
import burnsPutWater from './Burns/WhenToSay/putWater.svg';
import burnsPourOil from './Burns/WhenToSay/pourOil.svg';
import aFewSeconds from './Burns/WhenToSay/afewseconds.svg';
import manyMinutes from './Burns/WhenToSay/manyMinutes.svg';
import oneDay from './Burns/WhenToSay/day.svg';
import oneHour from './Burns/WhenToSay/hour.svg';
// Fractures
import fracturesBanner from './Fractures/Fractures.svg';
import coldCloth from './Fractures/WhatHelps/coldCloth.svg';
import support from './Fractures/WhatHelps/support.svg';
import injuredPartStill from './Fractures/WhatHelps/injuredPartStill.svg';
import healthFacility from './Fractures/WhatHelps/healthFacility.svg';
import strongPain from './Fractures/WhenToSay/pain.png';
import partSwollen from './Fractures/WhenToSay/swollen.png';
import partBent from './Fractures/WhenToSay/bent.png';
import cannotMove from './Fractures/WhenToSay/cantMove.png';
import skinInfection from './Fractures/WhenToSay/skininfection.svg';
import stomachIllness from './Fractures/WhenToSay/stomachillness.svg';
import brokenBone from './Fractures/WhenToSay/brokenBone.svg';
import changesOnSkin from './Fractures/WhenToSay/changesonskin.svg';
import massage from './Fractures/WhenToSay/massage.svg';
import continuePlaying from './Fractures/WhenToSay/continuePlaying.svg';
import fracturesRun from './Fractures/WhenToSay/run.svg';
// Choking
import coughing from './Choking/cough.svg';
import patBack from './Choking/WhatHelps/patBack.svg';
import stomachAche from './Choking/WhenToSay/stomachAche.svg';
import sneezing from './Choking/WhenToSay/sneezing.svg';
import stuckFood from './Choking/WhenToSay/stuckFood.svg';
import skinRash from './Choking/WhenToSay/skinRash.svg';
import feedBaby from './Choking/WhenToSay/feedBaby.svg';
import shakeBaby from './Choking/WhenToSay/shakeBaby.svg';
import patBaby from './Choking/WhenToSay/patBaby.svg';
import chockingRun from './Choking/WhenToSay/run.svg';
import callEmergency from './Swallowing/WhatHelps/callEmergency.svg';
import turnsBlue from './Swallowing/WhenToSay/turnsBlue.svg';
import standBehind from './Choking/WhatHelps/standbehind.svg';
import pushes from './Choking/WhatHelps/pushes.svg';
import fainted from './Choking/WhenToSay/fainted.svg';
import notBreathing from './Choking/WhenToSay/notbreathing.svg';
import rush from './Choking/WhenToSay/rush.svg';
// Swallowing
import swallowedBattery from './Swallowing/WhenToSay/swallowedBattery.svg';
import swallowingCough from './Swallowing/WhenToSay/cough.svg';
import freshAir from './Swallowing/WhatHelps/freshair.svg';
import washSkin from './Swallowing/WhatHelps/washskin.svg';
import washMouth from './Swallowing/WhatHelps/washmouth.svg';
import hospital from './Swallowing/WhatHelps/hospital.svg';
import sleepy from './Swallowing/WhenToSay/sleepy.svg';
import shaking from './Swallowing/WhenToSay/shaking.svg';
import throwingUp from './Swallowing/WhenToSay/throwingup.svg';
import swallowedCoughing from './Swallowing/WhenToSay/coughing.svg';
import stomachAching from './Swallowing/WhenToSay/ache.svg';
import sneezingAlot from './Swallowing/WhenToSay/sneezing.svg';
import swallowedPoison from './Swallowing/WhenToSay/poison.svg';
import sskinRash from './Swallowing/WhenToSay/rash.svg';

const FIRSTAIDIMAGES = {
  // Cuts and Wounds
  press,
  clean,
  cover,
  washHands,
  badPain,
  bite,
  deepCut,
  bleeding,
  pourOil,
  putSugar,
  toothpaste,
  cutsBanner,
  // Nose bleeding
  noseBleedingBanner,
  sitUp,
  leanFoward,
  pinchSoftPart,
  breatheViaMouth,
  alotOfBlood,
  bleedingNotStopping,
  breathingDifficulties,
  swollenNose,
  run,
  lieFlat,
  breatheViaNose,
  putThings,
  // Burns and scalds
  burnsBanner,
  burnsRest,
  stayAwayFire,
  coolWithWater,
  coverBurn,
  takeMedicine,
  burntHand,
  blister,
  fromChemicals,
  cantBreathe,
  burnsPutSugar,
  burnsPutWater,
  burnsPourOil,
  aFewSeconds,
  manyMinutes,
  oneDay,
  oneHour,
  // Fractures
  fracturesBanner,
  coldCloth,
  support,
  injuredPartStill,
  healthFacility,
  strongPain,
  partSwollen,
  partBent,
  cannotMove,
  skinInfection,
  stomachIllness,
  brokenBone,
  changesOnSkin,
  massage,
  continuePlaying,
  fracturesRun,
  // Choking
  coughing,
  patBack,
  stomachAche,
  skinRash,
  stuckFood,
  sneezing,
  feedBaby,
  shakeBaby,
  patBaby,
  chockingRun,
  pushes,
  standBehind,
  fainted,
  notBreathing,
  rush,
  // Swallowing
  callEmergency,
  turnsBlue,
  swallowedBattery,
  swallowingCough,
  freshAir,
  washSkin,
  washMouth,
  hospital,
  sleepy,
  shaking,
  throwingUp,
  swallowedCoughing,
  stomachAching,
  sneezingAlot,
  swallowedPoison,
  sskinRash,
};

export default FIRSTAIDIMAGES;
